import { ItemChartModel } from '../global/item-chart.model';

export class OrderChartModel {
  total: number = 0;
  states: ItemChartModel[] = [];
  types: ItemChartModel[] = [];
}
